import { useMutation } from "@tanstack/react-query";
import { UpdateTeamOperationRequest } from "@/Stub/V1";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";
import { TeamsApiClient } from "@/Service/Api/V1/ApiClients/TeamsApiClient";

export const useUpdateTeam = () => useMutation({
    mutationFn: async (data: UpdateTeamOperationRequest) => {
        try {
            return await TeamsApiClient.updateTeam(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});